import React from 'react';

import Banner from './banner';
import withPageComponents from '../../page/components/with-page-components';

import './results-footer-banner.less';

const ResultsFooterBanner = ({ vwaResultsFooterBanner }) => {
    if (!vwaResultsFooterBanner) return null;
    return <Banner banner={vwaResultsFooterBanner} />;
};

export default withPageComponents(ResultsFooterBanner, { components: ['vwaResultsFooterBanner'] });
